import {
  MERCHANT_CREATE_REQUEST, MERCHANT_CREATE_SUCCESS, MERCHANT_CREATE_FAIL, MERCHANT_CREATE_RESET,
  MERCHANT_BY_QR_REQUEST, MERCHANT_BY_QR_SUCCESS, MERCHANT_BY_QR_FAIL,
  MERCHANT_LIST_REQUEST, MERCHANT_LIST_SUCCESS, MERCHANT_LIST_FAIL,
} from '../constants/merchantConstants';

export const merchantCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_CREATE_REQUEST: return { loading: true };
    case MERCHANT_CREATE_SUCCESS: return { loading: false, data: action.payload };
    case MERCHANT_CREATE_FAIL:    return { loading: false, error: action.payload };
    case MERCHANT_CREATE_RESET:   return {};
    default: return state;
  }
};

export const merchantByQrReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_BY_QR_REQUEST: return { loading: true };
    case MERCHANT_BY_QR_SUCCESS: return { loading: false, merchant: action.payload };
    case MERCHANT_BY_QR_FAIL:    return { loading: false, error: action.payload };
    default: return state;
  }
};

export const merchantListReducer = (
  state = { items: [], page: 1, pages: 1, total: 0, systemMerchant: null },
  action
) => {
  switch (action.type) {
    case 'MERCHANT_LIST_REQUEST':
      return { ...state, loading: true };
    case 'MERCHANT_LIST_SUCCESS': {
      const payload = action.payload || {};
      const items =
        Array.isArray(payload.items) ? payload.items : Array.isArray(payload) ? payload : [];
      return {
        loading: false,
        items,
        total: payload.total || 0,
        page: payload.page || 1,
        pages: payload.pages || 1,
        systemMerchant: payload.systemMerchant || null,
      };
    }
    case 'MERCHANT_LIST_FAIL':
      return { loading: false, error: action.payload, items: [] };
    default:
      return state;
  }
};
